import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MonogramIcon } from "./monogram-icon";

const MESSAGES = [
  "We are in our 1st chapter",
  "New valuables — every week.",
];

export function AnnouncementBanner() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % MESSAGES.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="relative w-full bg-[#0b2d82] text-white">
      <a
        href="https://me.zurian.co.in"
        className="block w-full px-4 py-3 sm:py-3.5 transition-colors duration-500 hover:bg-[#071d57]"
        aria-label="Zurian — view our new collection"
      >
        <div className="mx-auto flex max-w-4xl items-center justify-center space-x-6 sm:space-x-8">
          <div className="flex flex-shrink-0 items-center space-x-2 sm:space-x-3">
            {[
              { size: "h-2.5 sm:h-3", delay: 0 },
              { size: "h-3.5 sm:h-4", delay: 0.2 },
              { size: "h-[18px] sm:h-5", delay: 0.4 },
            ].map((icon, i) => (
              <motion.div
                key={`left-${i}`}
                animate={{ scale: [0.85, 1.15, 0.85], opacity: [0.5, 1, 0.5] }}
                transition={{ duration: 4, delay: icon.delay, repeat: Infinity, ease: "easeInOut" }}
              >
                <MonogramIcon className={`${icon.size} w-auto text-[#C0A060]`} />
              </motion.div>
            ))}
          </div>

          <div className="relative flex h-8 w-full flex-1 items-center justify-center sm:h-6">
            <AnimatePresence mode="wait">
              <motion.span
                key={index}
                initial={{ opacity: 0, filter: "blur(4px)" }}
                animate={{ opacity: 1, filter: "blur(0px)" }}
                exit={{ opacity: 0, filter: "blur(4px)" }}
                transition={{ duration: 0.7, ease: "easeInOut" }}
                className="absolute w-full px-1 text-center font-heading text-[10px] uppercase leading-snug tracking-[0.1em] sm:text-[13px] sm:tracking-[0.15em]"
              >
                {MESSAGES[index]}
              </motion.span>
            </AnimatePresence>
          </div>

          <div className="flex flex-shrink-0 items-center space-x-2 sm:space-x-3">
            {[
              { size: "h-[18px] sm:h-5", delay: 0.4 },
              { size: "h-3.5 sm:h-4", delay: 0.2 },
              { size: "h-2.5 sm:h-3", delay: 0 },
            ].map((icon, i) => (
              <motion.div
                key={`right-${i}`}
                animate={{ scale: [1.15, 0.85, 1.15], opacity: [1, 0.5, 1] }}
                transition={{ duration: 4, delay: icon.delay, repeat: Infinity, ease: "easeInOut" }}
              >
                <MonogramIcon className={`${icon.size} w-auto text-[#C0A060]`} />
              </motion.div>
            ))}
          </div>
        </div>
      </a>
    </div>
  );
}
